import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { TellentHttpAuthApiService } from '@core/tellent-http-legacy';

import type { TellentSso, TellentSsoAppRole, TellentSsoSwitchableMode } from '../types';

@Injectable({ providedIn: 'root' })
export class TellentSsoHttpClient {
  public httpAuthApi = inject(TellentHttpAuthApiService);

  public fetch(): Observable<TellentSso> {
    return this.httpAuthApi.get('/sso/identity-provider');
  }

  public uploadMetadataXml(file: File, entityId?: string): Observable<TellentSso> {
    const data = new FormData();
    data.append('metadata_xml', file);
    if (entityId) {
      data.append('entity_id', entityId);
    }
    return this.httpAuthApi.post('/sso/identity-provider', null, data);
  }

  public replaceMetadataXml({
    file,
    code,
  }: {
    file: File;
    code: string | null;
  }): Observable<TellentSso> {
    const data = new FormData();
    data.append('metadata_xml', file);

    if (code) {
      data.append('code', code);
    }
    return this.httpAuthApi.put('/sso/identity-provider/metadata', null, data);
  }

  public updateRoles(
    defaultSeats: TellentSsoAppRole[],
    entityId?: string,
  ): Observable<{ defaultSeats: TellentSsoAppRole[] }> {
    return this.httpAuthApi.patch('/sso/identity-provider', undefined, {
      defaultSeats,
      ...(entityId ? { entityId } : {}),
    });
  }

  public changeMode({
    mode,
    code,
  }: {
    mode: TellentSsoSwitchableMode;
    code: string;
  }): Observable<TellentSso> {
    return this.httpAuthApi.put(`/sso/identity-provider/mode/${mode}`, undefined, { code });
  }

  public changeSessionLength({
    tokenExpirationHours,
    code,
  }: {
    tokenExpirationHours: number;
    code: string;
  }): Observable<TellentSso> {
    return this.httpAuthApi.put(`/sso/identity-provider/session-length`, undefined, {
      code,
      tokenExpirationHours,
    });
  }

  public delete(code: string) {
    return this.httpAuthApi.delete(`/sso/identity-provider`, { code });
  }
}
